import React from "react";

import Card3Items from "./Card3Items";




const Card3 = (props) => {

    return (
        <div className="container card3">
            <div className="row active-with-click">
                {props.meetups?.map(data => {
                    return (
                        <Card3Items
                            key={data.id}
                            id={data.id}
                            image={data.image}
                            title={data.title}
                            desctiption1={data.desctiption1}
                            description={data.description}

                        />

                    )
                })}


            </div>
        </div >)
}
export default Card3;